import { MyTableComponent } from "components"
import { Box } from "theme-ui"
import redselect from "./redselect.png"
import slidersign from "./slidersign.png"
import { useTranslation } from "react-i18next"

export const SystemMessages = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "IstVektor Mod Anzahl 2, Mod 1 Aus, Mod 2 Aus",
   infofive: "Fehler",
  },
 ]

 const columns = [
  {
   Header: () => (
    <div className="pl-2">
     <span>
      <img src={data[0].infoone} alt="selecticon" />
     </span>
    </div>
   ),
   accessor: "infoone",
   Cell: ({ row }: any) => (
    <div>
     <span>
      <img src={row.original.infoone} alt="selecticontwo" />
     </span>
    </div>
   ),
  },
  { Header: t("time"), accessor: "infotwo" },

  {
   Header: t("Report"),

   Cell: ({ row }: any) => (
    <div className="flex items-center ">
     <span>{row.original.infothree}</span>
     <div>
      <svg
       className="cursor-pointer"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
         />
        </g>
       </g>
      </svg>
     </div>
    </div>
   ),
  },
  {
   Header: t("grade"),
   Cell: ({ row }: any) => (
    <div className="text-dark-pink bg-light-pink text-center py-1 border-light-pink border">
     {row.original.infofive}
    </div>
   ),
  },
 ]

 return (
  <div className="relative h-screen md:h-screen lg:h-full w-[96%] mx-auto">
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("systemMessages")}</h1>
    <div className="bg-white h-10 w-10 rounded flex justify-center items-center">
     <img src={slidersign} alt="slidersignimg" />
    </div>
   </div>
   <Box bg="highlight" className="py-2 px-2">
    <Box bg="light_gray" className="flex justify-between  py-4 rounded mx-2 px-3 ">
     <h1 className="font-semibold font-sm Jakarta-font">411 {t("systemMessages")}</h1>

     <div className="custom-checkbox">
      <input type="checkbox" id="updata" />
      <label className="font-semibold font-sm Jakarta-font" htmlFor="updata">
       {t("updateAutomatically")}
      </label>
     </div>
    </Box>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={false} columns={columns} data={data} paginate={true} />
  </div>
 )
}
